module.exports = __webpack_public_path__ + "img/stock5.21d75be1.png";